const formHeader = document.querySelector('.page-header__content--form');

if (formHeader) {
    const row = formHeader.querySelector('.row');
    const heading = formHeader.querySelector('.content h1');

    if (row && heading) {
        const originalParent = heading.parentElement;
        const originalNextSibling = heading.nextSibling;

        const mobileWrap = document.createElement('div');
        mobileWrap.className = 'col-12 page-header__heading-mobile';
        const mobileContent = document.createElement('div');
        mobileContent.className = 'content';
        mobileWrap.appendChild(mobileContent);

        const mq = window.matchMedia('(max-width: 1199px)');

        const apply = () => {
            if (mq.matches) {
                if (!mobileWrap.parentElement) {
                    row.insertBefore(mobileWrap, row.firstChild);
                }
                if (heading.parentElement !== mobileContent) {
                    mobileContent.appendChild(heading);
                }
            } else {
                if (heading.parentElement !== originalParent) {
                    originalParent.insertBefore(heading, originalNextSibling);
                }
                if (mobileWrap.parentElement) {
                    mobileWrap.remove();
                }
            }
        };

        apply();
        mq.addEventListener('change', apply);
    }
}
